import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, isDevMode } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';
import { SocialAuthServiceConfig, GoogleLoginProvider } from '@abacritt/angularx-social-login';
import { MatTooltipModule } from '@angular/material/tooltip';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import localeAr from '@angular/common/locales/ar';

// Enregistre les locales nécessaires
registerLocaleData(localeFr);
registerLocaleData(localeEn);
registerLocaleData(localeAr);

// // for HttpClient import:
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
// // for Router import:
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
// // for Core import:
import { LoadingBarModule } from '@ngx-loading-bar/core';

import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { AuthModule } from './auth/auth.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { JwtInterceptor } from './shared/interceptors/jwt.interceptor';
import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { SinglePageComponent } from './components/single-page/single-page.component';
import { SecurityInterceptor } from './shared/interceptors/security.interceptor';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { NgxPrintModule } from 'ngx-print';
import { Language } from './shared/services/layout.service';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { ServiceWorkerModule } from '@angular/service-worker';

const GOOGLE_CLIENT_ID = '442102252277-nsod4h0qjkja1i330enki083be350i9n.apps.googleusercontent.com';
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
	declarations: [AppComponent, SinglePageComponent],
	imports: [
		BrowserModule,
		FormsModule,
		ReactiveFormsModule,
		BrowserAnimationsModule,
		OverlayModule,
		AuthModule,
		SharedModule,
		AppRoutingModule,
		HttpClientModule,
		MatTooltipModule,
		NgSelectModule,
		NgbModule,
		NgxPrintModule,
		ZXingScannerModule,
		ToastrModule.forRoot(),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			},
			defaultLanguage: getCurrentLanguage()?.code
		}),

		//     // for HttpClient use:
		LoadingBarHttpClientModule,
		//     // for Router use:
		LoadingBarRouterModule,
		//     // for Core use:
		LoadingBarModule,
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: !isDevMode(),
			// Register the ServiceWorker as soon as the application is stable
			// or after 30 seconds (whichever comes first).
			registrationStrategy: 'registerWhenStable:30000'
		})
	],
	providers: [
		{
			provide: 'SocialAuthServiceConfig',
			useValue: {
				autoLogin: false,
				providers: [
					// {
					// 	id: GoogleLoginProvider.PROVIDER_ID,
					// 	provider: new GoogleLoginProvider(GOOGLE_CLIENT_ID)
					// }
				],
				onError: error => {
					console.log(error);
				}
			} as SocialAuthServiceConfig
		},
		{ provide: LOCALE_ID, useValue: getCurrentLanguage()?.code },
		CookieService,
		{ provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: SecurityInterceptor, multi: true },
		{ provide: LocationStrategy, useClass: PathLocationStrategy }
	],
	bootstrap: [AppComponent]
})
export class AppModule {}

export function getCurrentLanguage(): Language {
	const currentLang = localStorage.getItem('lang');
	let defaultLanguage;
	if (currentLang && currentLang !== 'undefined') {
		defaultLanguage = JSON.parse(currentLang);
	} else {
		defaultLanguage = {
			language: 'Français',
			code: 'fr',
			icon: 'fr'
		};
	}
	return defaultLanguage;
}
